module.exports = __webpack_public_path__ + "img/qrCode.35db449d.png";